// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC9eSEjLxpYmPOwwDlqBNhYtqHO26NC1-k",
    authDomain: "buyoi-portfolio1.firebaseapp.com",
    databaseURL: "https://buyoi-portfolio1-default-rtdb.firebaseio.com",
    projectId: "buyoi-portfolio1",
    storageBucket: "buyoi-portfolio1.appspot.com",
    messagingSenderId: "808505174201",
    appId: "1:808505174201:web:db56830518f8e3e55b9368",
    measurementId: "G-QWJ9B07LM7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);